import {Component, HostListener, OnInit} from '@angular/core';
import {AmenitiesService} from '../../../services/amenities.service';
import {finalize, flatMap, map, tap} from 'rxjs/operators';

@Component({
    selector: 'disabled-date-modal',
    templateUrl: './disabled-date-modal.component.html',
    styleUrls: ['./disabled-date-modal.component.scss']
})
export class DisabledDateModalComponent implements OnInit {
    disabledDate: any;
    showModal: boolean;

    existingDisabledDates = [];

    showAddNoteForm: boolean = false;
    newNote: string = '';
    savingNote: boolean;

    private amenity: any;

    constructor(
        private amenitiesService: AmenitiesService
    ) {
    }

    ngOnInit() {
        this.disabledDate = this.amenitiesService.selectedDisabledDate;
        this.showModal = this.amenitiesService.isDisabledDateModalShown;
        this.fetchAmenity()
            .pipe(
                flatMap(() => this.fetchDisabledDates(this.disabledDate.amenityId))
            )
            .subscribe(
                () => 0,
                (error) => this.amenitiesService.api.errorHandler(error, 'Failed to fetch important data')
            );
    }

    fetchAmenity() {
        return this.amenitiesService.getAmenity(this.disabledDate.amenityId)
            .pipe(
                tap(
                    amenity => this.amenity = amenity
                )
            );
    }

    hideModal() {
        this.amenitiesService.isDisabledDateModalShown = false;
    }

    fetchDisabledDates(amenityId: number) {
        return this.amenitiesService.getDisabledDates(null, null, amenityId)
            .pipe(
                map(body => body.entities),
                tap(disabledDates => this.existingDisabledDates = disabledDates)
            );
    }

    addNote() {
        this.showAddNoteForm = true;
    }

    cancelNote() {
        this.newNote = '';
        this.showAddNoteForm = false;
    }

    updateDisabledDates(data) {
        const url = `/v1/amenity/${this.disabledDate.amenityId}.json`;
        return this.amenitiesService.api.patch('domainAmenities', url, data);
    }

    saveNote() {
        const excludedKeys = new Set([
            'id',
            'amenityId',
            'amenityName'
        ]);
        const data = {
            disabledDates: [
                ...this.existingDisabledDates.filter(date => date.id !== this.disabledDate.disabledDateId)
                    .map(date => Object.keys(date)
                        .filter(key => !excludedKeys.has(key))
                        .reduce((newObject, key) => {
                            newObject[key] = date[key];
                            return newObject;
                        }, {})
                    ),
                {
                    startDate: this.disabledDate.start,
                    endDate: this.disabledDate.end,
                    note: this.newNote
                }
            ],
            timeSequenceType: this.amenity.timeSequenceType
        };
        const afterSave = () => {
            this.existingDisabledDates = data.disabledDates;
            this.disabledDate.note = this.newNote;
            this.cancelNote();
        };
        this.savingNote = true;
        this.updateDisabledDates(data)
            .pipe(
                tap(() => this.amenitiesService.cleanCalendarEvents()),
                tap(() => this.amenitiesService.updateView('Disabled Date Updated')),
                finalize(() => this.savingNote = false),
            )
            .subscribe(
                afterSave,
                (error) => this.amenitiesService.api.errorHandler(error, 'Update failed!'
                )
            );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/disabled-date-modal/disabled-date-modal.component.ts